import React from 'react'
import AdminLogin from '../AdminComponents/AdminLogin/AdminLogin'
import Footer from '../Components/Footer/Footer'
import LoginTopBar from '../Components/LoginTopBar/LoginTopBar'

const AdminLoginPage = () => {
  return (
    <>
    <LoginTopBar/>
        <AdminLogin/>
        {/* <Footer/> */}
    
    </>
  )
}

export default AdminLoginPage